import { render } from "./Repos.vue?vue&type=template&id=574bde9c&scoped=true"
import script from "./Repos.vue?vue&type=script&lang=js"
export * from "./Repos.vue?vue&type=script&lang=js"

import "./Repos.vue?vue&type=style&index=0&id=574bde9c&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574bde9c"]])

export default __exports__